import { useEffect, useRef } from "react";
import moment from 'moment';

const PayPalButtons = ({ token, selectedTier, selectedVehicle, onSubscriptionApprove }) => {
  const planIdRef = useRef();
  const vehiclesRef = useRef();
  const tokenRef = useRef();

  const options = {
    style: {
        shape: 'pill',
        color: 'blue',
        layout: 'vertical',
        label: 'subscribe'
    },
    createSubscription: (data, actions) => {
      return onCreateSubscription(data, actions)
    },
    onApprove: function(data, actions) {
      onSubscriptionApprove(data.subscriptionID)
    }
  }

  useEffect(() => {
    if (selectedTier && selectedVehicle && selectedVehicle.length > 0) {
      // only render button once we have the correct values
      window.paypal.Buttons(options).render('#paypal-button-container')
    }
  }, [selectedTier, selectedVehicle])

  useEffect(() => {
    planIdRef.current = selectedTier.planId;
  }, [selectedTier])

  useEffect(() => {
    tokenRef.current = token
  }, [token])

  useEffect(() => {
    vehiclesRef.current = selectedVehicle
  }, [selectedVehicle])

  const onCreateSubscription = async (data, actions) => {
    try {
      // create a subscription with plan ID 
      const rawResponse =  await fetch(`https://api-m.paypal.com/v1/billing/subscriptions`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenRef.current}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          plan_id: planIdRef.current,
          start_time: new Date(moment().add(1, 'days').startOf('day')),
          quantity: `${vehiclesRef.current.length}`
        })
      });

      await rawResponse.json()

      // return success to rest of the PayPal process
      // subscription created, this prompts user login
      return actions.subscription.create({
        'plan_id': planIdRef.current,
        'quantity': `${vehiclesRef.current.length}`
      });

      
    } catch (error) {
      console.log(error)
    }
  }
  
  return (
    <>
      <div id="paypal-button-container"></div>
    </>
  )
}

export default PayPalButtons;